import { utils } from "@/extend-vue";
import vue, { VueConstructor } from "vue";
import main from "../main";
import Vue from "vue";
import { CombinedVueInstance } from "vue/types/vue";
// import SetTypeTs from "@/components/SetType/SetType.ts";
function getParents(elem: HTMLElement, tag: string): HTMLElement[] | HTMLElement {
	var parents = new Array();
	while (elem.parentNode) {
		parents.push((<HTMLElement>elem).parentNode)
		if (tag && (<HTMLElement>elem.parentNode).tagName == tag) {
			return <HTMLElement>elem.parentNode
		}
		elem = (<HTMLElement>elem.parentNode);
	}
	return parents;
}

function arrIndex(arr: NodeList, val: any) {
	for (var i = 0; i < arr.length; i++) {
		if (arr[i] == val) return i;
	}
	return -1;
}

function focusStepInput(rows: NodeList, rowIndex: number, index: number, up: boolean) {
	let step = up ? -1 : 1;

	function filterDis() {
		let stepTd = (<HTMLElement>rows[rowIndex + step]).querySelectorAll("td")[index],
			stepInput = (<HTMLElement>stepTd.querySelector("input"));
		if (stepInput.getAttribute("disabled") == null) {
			(<HTMLElement>stepInput).focus();
		} else {
			if (up)
				step -= 1;
			else
				step += 1;
			if (rowIndex + step != 0 && rowIndex + step != rows.length - 1) filterDis();
		}
	}

	if (up) {
		if (rowIndex != 0)
			filterDis();
	} else {
		if (rowIndex != rows.length - 1)
			filterDis();
	}
}

function focusSideInput(inputs: NodeList, index: number, left: boolean) {
	let step = left ? -1 : 1;
	if (index + step != -1 && index + step != inputs.length)
		(<HTMLElement>inputs[index + step]).focus();
}

let _utils: utils = {
	includeCn(text: string) {
		return /^[\u3220-\uFA29]+$/.test(text);
	},
	sendToElectron(message: string, arg?, arg2?, arg3?, arg4?, arg5?, arg6?) {
		if (message === "download" || message === "download-pdf") {
			arg = arg.replace("http://", "https://");
			console.log("download: ", arg);
			window.open(arg);
		} else if (message === "set-clipboard") {
			// @ts-ignore
			navigator.clipboard.writeText(arg);
		} else if (message === "open-robot") {
			window.open("https://ai.jinzhangshi.com");
		}
		// ipcRenderer.send(message, arg, arg2, arg3, arg4, arg5, arg6);
	},
	simpleDateFormat: (date: Date, format: string, need?: boolean) => {
		let monthStr = [
			"01",
			"02",
			"03",
			"04",
			"05",
			"06",
			"07",
			"08",
			"09",
			"10",
			"11",
			"12"
		];
		if (format === "day" || format === "d") {
			let day =
				+date.getDate() < 10
					? "0" + date.getDate().toString()
					: date.getDate();
			if (need)
				return (
					date.getFullYear() +
					"-" +
					monthStr[date.getMonth()] +
					"-" +
					day
				);
			else return date.getFullYear() + monthStr[date.getMonth()] + day;
		} else if (format === "month" || format === "m") {
			if (!need) return date.getFullYear() + monthStr[date.getMonth()];
			else return date.getFullYear() + "-" + monthStr[date.getMonth()];
		}
		return "";
	},
	// 计算两个时间的月份差
	getMonthBetween(start: Date, end: Date) {
		var date2Mon;
		var startDate = start.getDate() + start.getHours() / 24 + start.getMinutes() / 24 / 60;
		var endDate = end.getDate() + end.getHours() / 24 + end.getMinutes() / 24 / 60;
		if (endDate >= startDate) {
			date2Mon = 0;
		} else {
			date2Mon = -1;
		}
		return (end.getFullYear() - start.getFullYear()) * 12 + end.getMonth() - start.getMonth() + date2Mon;
	},
	// 时间增加或减少
	dateAdd(date, strInterval, number) {  //参数分别为日期对象，增加的类型，增加的数量
		let dtTmp: string = date.toDateString();
		switch (strInterval) {
			case "second":
			case "s":
				return new Date(Date.parse(dtTmp) + (1000 * number));
			case "minute":
			case "n":
				return new Date(Date.parse(dtTmp) + (60000 * number));
			case "hour":
			case "h":
				return new Date(Date.parse(dtTmp) + (3600000 * number));
			case "day":
			case "d":
				return new Date(Date.parse(dtTmp) + (86400000 * number));
			case "week":
			case "w":
				return new Date(Date.parse(dtTmp) + ((86400000 * 7) * number));
			case "month":
			case "m":
				return new Date(date.getFullYear(), (date.getMonth()) + number, date.getDate(), 0, date.getMinutes(), date.getSeconds());
			case "year":
			case "y":
				return new Date((date.getFullYear() + number), date.getMonth(), date.getDate(), 0, date.getMinutes(), date.getSeconds());
			default:
				return new Date();
		}
	},

	// 字符串转换为日期
	strToDate(str: string, day?: boolean, sep?: string) {
		if (!sep) {
			if (day) {
				let date = str.substr(0, 4) + "-" + str.substr(4);
				return new Date(date);
			} else {
				let date = str.substr(0, 4) + "-" + str.substr(4, 2) + "-" + str.substr(6, 2);
				return new Date(date);
			}
		} else {
			return new Date(str);
		}
	},
	// 自定义清空localstorage方法,为多处调用方便
	clearStorage(...args: string[]) {
		if (args.length === 0) {
			localStorage.removeItem("token");
			localStorage.removeItem("no");
			localStorage.removeItem("role");
			localStorage.removeItem("level");
			localStorage.removeItem("name");
		} else {
			args.forEach(v => {
				localStorage.removeItem(v);
			});
		}
	},

	// 自动将焦点focus到首个input中
	focusFirstInput(inputName?: string) {
		vue.nextTick().then(() => {
			let input;
			if (inputName)
				input = <HTMLInputElement>(
					document.querySelector(`input[name=${inputName}]`)
				);
			else
				input = <HTMLInputElement>(
					document.querySelector("input[name=first-input]")
				);
			if (input != null) input.focus();
		});
	},

	// 为空(或为0)判断
	notNull(str) {
		let flag = true;
		for (let i = 0; i < str.length; i++) {
			if (str[i] === undefined) {
				flag = false;
				break;
			}
			if (str[i] === null) {
				flag = false;
				break;
			}
			if (str[i] != undefined) {
				if (String(str[i]) === "" || Number(str[i]) === 0) {

					flag = false;
					break;
				}
			}

		}
		return flag;
	},

	transNum(num) {
		if (num === 1) return true;
		else return false;
	},

	getPageIndex(index, size, page) {
		return (index + 1) + size * (page - 1);
	},

	// 数字转金额格式
	currency(numberS: string, zero: boolean, unit: string, places: number, symbol: string, thousand: string, decimal: string) {
		// number过滤器前面的值,places保留几位小数，不传默认为2,symbol货币符号，默认为空（$,￥等）
		// thousand千位分隔符，默认为,decimal小数分隔符，默认为. ,正常什么都不用传，都是默认就ok
		// number = number.replace(/,/g, "");
		let number = numberS;
		if (number === null || +number == 0) {
			if (zero == true) return "0.00"
			return ""
		}
		if (number != null && +number != 0) {
			number = numberS.toString().replace(/,/g, "");
		}
		if (unit === "万") {
			if (+number > 10000) {
				number = (+number / 10000).toString();
				places = 4;
			} else {
				places = 2;
				unit = "";
			}
		} else if (unit === "") {
			number = (+number / 10000).toString();
			places = 4;
		} else {
			places = !isNaN(places = Math.abs(places)) ? places : 2;
			unit = unit !== undefined ? unit : "";
		}
		symbol = symbol !== undefined ? symbol : "";
		thousand = thousand || ",";
		decimal = decimal || ".";
		let negative = +number < 0 ? "-" : "",
			i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
			j;
		j = (j = i.length) > 3 ? j % 3 : 0;
		return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(+number - Number(i)).toFixed(places).slice(2) : "") + unit;
	},

	// 判断用户权限
	canControl() {
		if (main) return main.$store.state.accountBook.accounterNo.indexOf(main.$store.state.account.no) === 0 && Math.abs(main.$store.state.account.no.length - main.$store.state.accountBook.accounterNo.length) <= 4 || main.$store.state.account.role.includes("管理员");
		return false;
	},

	// 中文大写
	zhMoney(n) {
		var unit = "仟佰拾亿仟佰拾万仟佰拾元角分", str = "";
		n += "00";
		var p = n.indexOf(".");
		if (p >= 0)
			n = n.substring(0, p) + n.substr(p + 1, 2);
		unit = unit.substr(unit.length - n.length);
		for (var i = 0; i < n.length; i++)
			str += "零壹贰叁肆伍陆柒捌玖".charAt(+n.charAt(i)) + unit.charAt(i);
		if (String(n).indexOf("-") == -1) {
			if (/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
				return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
			} else {
				if (n == "000") return "零元整"
				else {
					return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
				}
			}
		} else {
			let newStr = str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/^元零?|零分/g, "").replace(/元$/g, "元整"),
				need = newStr.slice(1),
				show = "负".concat(need);
			return show;
		}
	},
	// 获取备注
	getRemarks(id?: any) {
		let accountbookId = null
		if(main) accountbookId = main.$store.state.accountBook.id
		else accountbookId = id
		vue.axios
			.post(
				`accountbookremark/find`, { accountBookId: accountbookId }
			)
			.then(res => {
				main.$store.dispatch("changeAccountRemark", res.data);

			});
	},

	// 获取征期
	getCollectDate() {
		if (main) {
			vue.axios
				.get(
					`collectionperiods/current?accounterNo=${main.$store.state.account.no}`)
				.then(res => {
					main.$store.dispatch("updateCollectMessage", res.data);
				});
		}
	},
	// 键盘快捷键
	arrowPress(e, numInput?, disUpDown?) {
		if (numInput) {
			let keycodes = [8, 9, 12, 13, 32, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 109, 110, 187, 189, 190]
			if (keycodes.indexOf(e.keyCode) == -1) {
				e.preventDefault();
				return
			}
		}

		let target = <HTMLElement>e.target;
		let currentTd = getParents(target, "TD"),
			currentRow = getParents(target, "TR"),
			curTds = (<HTMLElement>currentRow).querySelectorAll("td"),
			tbody = (<HTMLElement>getParents(target, "TBODY")),
			rows = tbody.querySelectorAll("tr"),
			rowIndex = arrIndex(rows, currentRow),
			curIndex = arrIndex(curTds, currentTd),
			rowInputs = (<HTMLElement>currentRow).querySelectorAll("input:enabled:not([type=checkbox])"),
			curInput = target,
			iIndex = arrIndex(rowInputs, curInput);

		if (e.keyCode == 38) {
			if (!disUpDown) {
				e.preventDefault();
				focusStepInput(rows, rowIndex, curIndex, true)
			}
		} else if (e.keyCode == 40) {
			if (!disUpDown) {
				e.preventDefault();
				focusStepInput(rows, rowIndex, curIndex, false)
			}
		} else if (e.keyCode == 37) {
			e.preventDefault();
			focusSideInput(rowInputs, iIndex, true)
		} else if (e.keyCode == 39) {
			e.preventDefault();
			focusSideInput(rowInputs, iIndex, false)
		} else if (e.keyCode == 13) {
			let allInputs = tbody.querySelectorAll("input:enabled:not([type=checkbox])"),
				i = arrIndex(allInputs, curInput);

			if (i < allInputs.length - 1)
				(<HTMLElement>allInputs[i + 1]).focus()
			else
				(<HTMLElement>allInputs[0]).focus();
		}
	},

	// 对大于指定条数的凭证进行分页
	pageableVoucher(pageSize, vouchers) {
		let vouchersCopy: Voucher.Voucher[] = JSON.parse(JSON.stringify(vouchers));
		for (let i = 0; i < vouchersCopy.length; i++) {
			let voucher = vouchersCopy[i];
			if (voucher.voucherRecords.length > pageSize) {
				let oldRecords = voucher.voucherRecords;
				let pages = Math.ceil(oldRecords.length / pageSize);
				let curPage = 1;
				voucher.voucherRecords = oldRecords.slice(0, pageSize);
				voucher.currentPage = curPage;
				voucher.totalPage = pages;
				for (let j = 1; j < pages; j++) {
					let tmpVoucher: Voucher.Voucher = JSON.parse(JSON.stringify(voucher));
					tmpVoucher.currentPage = j + 1;
					tmpVoucher.totalPage = pages;
					tmpVoucher.voucherRecords = [];
					if (j != pages - 1) {
						for (let k = j * pageSize; k < pageSize * (j + 1); k++) {
							tmpVoucher.voucherRecords.push(oldRecords[k]);
						}
					} else {
						for (let k = j * pageSize; k < oldRecords.length; k++) {
							tmpVoucher.voucherRecords.push(oldRecords[k]);
						}
					}
					vouchersCopy.splice(i + j, 0, tmpVoucher);
				}
			}
		}
		return vouchersCopy;
	},

	// 设置税务品目
	setTaxType(book) {
		// if (book.accountBookInfo != null) {
		// 	if (book.accountBookInfo.businessType === 0) {
		// 		new SetTypeTs(book);

		// 	}
		// }
	},

	// 更新处理
	updateHandle(message, doUpdate = true) {
		localStorage.setItem("showNotice", "true");
		if (process.env.NODE_ENV === "development") {
			if (main) main.$alert("改一下版本号吧...");
		} else {
			if (doUpdate && !main.$store.state.updateState.visble) this.sendToElectron(message);
			if (main) main.$store.dispatch("toggleUpdate", true);
		}
	},

	// 身份证年龄判断
	isCorrectAge(age: string) {
		let year = age.substr(6, 4);
		let month = age.substr(10, 2);
		let day = age.substr(12, 2);
		let date = new Date()
		let nowYear = date.getFullYear()
		let young = this.dateAdd(new Date(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()), "y", -18)
		let old = this.dateAdd(new Date(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()), "y", -60)
		if (new Date(year + "-" + month + "-" + day) <= young && new Date(year + "-" + month + "-" + day) >= old) return true
		else return false
	},

	/**
	 * 插件---一键登录/勾选认证
	 */
	async oneKeyFn(id: number, page: any, type: "勾选认证" | "一键登录" = "勾选认证") {
		const h = page.$createElement;
		const download = () => {
			page.$message({
				message: h("p", undefined, [
					h("span", undefined, "未检测到插件, 请保持插件正在运行, 可"),
					h("el-link", {
						attrs: { href: "https://hongfund-desktop.oss-cn-shanghai.aliyuncs.com/rpa/plugin/%E9%87%91%E8%B4%A6%E5%B8%88%E4%BC%9A%E8%AE%A1%E5%8A%A9%E6%89%8B-setup.exe" }
					}, "点击此处下载")
				]),
				type: "error"
			});
		}
		page.$message({
			message: h("p", undefined, [
				h("span", undefined, "该功能需要安装插件, 请保持插件正在运行")
			])
		});

		let isOnline = null;
		try {
			isOnline = await Vue.axios.get("http://localhost:3060/", {
				timeout: 10000
			});
		} catch (e) {
			isOnline = null;
			download();
		}
		if (isOnline && isOnline.data.code === 200) {
			const urlPrefix = process.env.VUE_APP_TITLE === "jzs" ? "https://fc.hongfund.com:8602/api/" : "";
			const taxData = await Vue.axios.get(`${urlPrefix}accountbooks/tax?id=${id}&actionId=${type === "一键登录" ? 303 : 302}`);
			taxData.data.data.type = type;
			taxData.data.data.env = process.env.VUE_APP_TITLE;
			await Vue.axios.post("http://localhost:3060/plugin/task/jump", taxData.data.data);
		} else {
			download();
		}
	},
	async oneKeyLogin(id: number, page: CombinedVueInstance<Vue, object, object, object, Record<never, any>>, type: "勾选认证" | "一键登录" = "勾选认证") {
		// console.log(page)
		console.log(page)
		page.$onekey(id, type);
	},

	/**
	 * 个税更正登录 --- 插件
	 */
	async ptaxPlugin(id: number, page: any, type: "个税登录" | "个税上传" = "个税登录", env?: string) {
		const h = page.$createElement;
		const download = () => {
			page.$message({
				message: h("p", undefined, [
					h("span", undefined, "未检测到插件, 请保持插件正在运行, 可"),
					h("el-link", {
						attrs: { href: "https://hongfund-desktop.oss-cn-shanghai.aliyuncs.com/rpa/plugin/%E9%87%91%E8%B4%A6%E5%B8%88%E4%BC%9A%E8%AE%A1%E5%8A%A9%E6%89%8B-setup.exe" }
					}, "点击此处下载")
				]),
				type: "error"
			});
		}

		page.$message({
			message: h("p", undefined, [
				h("b", { style: { display: "block" } }, "亲, 请务必关闭 杀毒类软件以保证个税更正可以不被误杀。"),
				h("span", undefined, "该功能需要安装个税助手插件, 请保持插件正在运行")
			])
		});

		let isOnline = null;
		try {
			isOnline = await Vue.axios.get("http://localhost:3070/ptax/", {
				timeout: 10000
			});
		} catch (e) {
			download();
			isOnline = null;
			throw e;
		}

		if (isOnline && isOnline.data.code === 200) {
			const urlPrefix = process.env.VUE_APP_TITLE === "jzs" ? "https://fc.hongfund.com:8602/api/" : "";
			const taxData = await Vue.axios.get(`${urlPrefix}accountbooks/tax?id=${id}&actionId=${type === "个税登录" ? 305 : 306}`);
			taxData.data.data.type = type;
			taxData.data.data.env = process.env.VUE_APP_TITLE === "jzs" ? "jzs" : "production";
			if (type === "个税登录") {
				return await Vue.axios.post("http://localhost:3070/ptax/plugin/reset/plugin", taxData.data.data);
			} else {
				return await Vue.axios.post("http://localhost:4060/tax", taxData.data.data);
			}
		} else {
			download();
			throw isOnline;
		}
	},

	async wait(time = 2000) {
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve();
			}, time);
		})
	},

	async ptaxCheckUpload() {
		let progressing = true;
		for (let i = 0; i < 100 && progressing; i++) {
			await this.wait(3000);
			const res = await Vue.axios({
				url: "http://localhost:3070/ptax/plugin/reset/check",
				method: "GET"
			});
			if (res.data.code === 200 || res.data.code === 202 || res.data.code === 203) {
				progressing = false;
				return res.data;
			} else {
				continue;
			}
		}

		return null;
	}


};

vue.utils = _utils;

vue.use(Vue => {
	Vue.prototype.$utils = _utils;
});
